<template>
  <div class="container assessment-management-container">
    <el-card shadow="hover">

      <div v-if="viewMode === 'list'">
        <div class="card-header">
          <h2>إدارة تقييماتي</h2>
          <el-button type="primary" @click="showCreateView">
            <el-icon><Plus /></el-icon> إنشاء تقييم جديد
          </el-button>
        </div>
        <el-divider />
        <el-alert
          title="مرحباً بك في واجهة التقييمات"
          type="info"
          :description="`هذه الواجهة تعرض التقييمات الخاصة بك للسنة الدراسية النشطة (${activeStudyYear ? activeStudyYear.name : ''}).`"
          :closable="false" show-icon style="margin-bottom: 20px;"
        />
        <div class="filter-section">
            <el-select v-model="filters.class_id" placeholder="عرض حسب الصف" clearable @change="handleClassFilterChange" style="width: 250px;">
                <el-option v-for="cls in teacherClasses" :key="cls.id" :label="cls.name" :value="cls.id" />
            </el-select>
            <el-select v-model="filters.section_id" placeholder="عرض حسب القسم" clearable @change="fetchAssessments" :disabled="!filters.class_id" style="width: 250px;">
                <el-option v-for="sec in sectionsForFilter" :key="sec.id" :label="sec.name" :value="sec.id" />
            </el-select>
        </div>
        <el-table :data="assessments" v-loading="loading" border style="width: 100%">
          <el-table-column prop="title" label="عنوان التقييم" />
          <el-table-column prop="course_offering.subject.name" label="المادة" />
          <el-table-column prop="section.name" label="القسم" />
          <el-table-column label="نوع التسليم" align="center" width="160">
            <template #default="{ row }">
              <el-tag :type="row.is_online_quiz ? 'success' : 'primary'" effect="dark">
                <el-icon style="vertical-align: middle; margin-right: 4px;">
                  <component :is="row.is_online_quiz ? 'Monitor' : 'School'"></component>
                </el-icon>
                <span style="vertical-align: middle;">{{ row.is_online_quiz ? 'إلكتروني' : 'بالمدرسة' }}</span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="الدرجات المرصودة" width="160" align="center">
            <template #default="{ row }">
                <el-tag :type="row.student_scores_count > 0 ? 'primary' : 'info'" effect="light">
                    {{ row.student_scores_count }} / {{ row.students_count || 'N/A' }} طالب
                </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="الإجراءات" width="320" fixed="right" align="center">
              <template #default="{ row }">
                <el-button size="small" type="primary" @click="openGradingView(row)" :icon="Edit">رصد الدرجات</el-button>
                <el-button 
        size="small" 
        type="default" 
        @click="printGradesReport(row)" 
        :icon="Printer" 
        :disabled="row.student_scores_count === 0"
        plain>
        طباعة
    </el-button>

    <el-button 
        size="small" 
        type="success" 
        @click="exportGrades(row)" 
        :icon="Download" 
        :disabled="row.student_scores_count === 0"
        plain>
        تصدير Excel
    </el-button>
                <el-popconfirm title="هل أنت متأكد من الحذف؟" @confirm="deleteAssessment(row.id)">
                  <template #reference><el-button size="small" type="danger" :icon="Delete">حذف</el-button></template>
                </el-popconfirm>
                
              </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination v-if="pagination.total > 0" @current-change="handleCurrentChange" v-model:currentPage="pagination.current_page" :page-size="pagination.per_page" layout="total, prev, pager, next" :total="pagination.total" background />
        </div>
      </div>
      
      <div v-if="viewMode === 'create' || viewMode === 'edit'">
        <div class="card-header">
          <h2>{{ dialogTitle }}</h2>
          <el-button @click="showListView">الرجوع للقائمة</el-button>
        </div>
        <el-divider />
        <el-steps :active="activeStep" finish-status="success" simple style="margin-bottom: 30px;">
          <el-step title="اختيار المقرر" :icon="CollectionTag" />
          <el-step title="تفاصيل التقييم" :icon="EditPen" />
          <el-step title="إضافة أسئلة (اختياري)" :icon="Finished" />
        </el-steps>
        <el-form :model="form" ref="formRef" label-position="top" :rules="rules">
          <div v-show="activeStep === 0">
              <el-alert title="الخطوة الأولى: تحديد المقرر" description="اختر الصف والشعبة لعرض المواد التي تدرسها، ثم اختر المادة التي تريد إنشاء تقييم لها." type="info" :closable="false" show-icon style="margin-bottom: 20px;" />
              <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="اختر الصف الدراسي" prop="class_id">
                        <el-select v-model="form.class_id" placeholder="الصف" @change="onFormClassChange" style="width: 100%;">
                        <el-option v-for="cls in teacherClasses" :key="cls.id" :label="cls.name" :value="cls.id" />
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="اختر الشعبة" prop="section_id">
                        <el-select v-model="form.section_id" placeholder="الشعبة" @change="onFormSectionChange" :disabled="!form.class_id" style="width: 100%;">
                        <el-option v-for="sec in sectionsForForm" :key="sec.id" :label="sec.name" :value="sec.id" />
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="اختر المادة (المقرر)" prop="course_offering_id" >
                        <el-select v-model="form.course_offering_id" filterable placeholder="المقرر" style="width: 100%;" :disabled="!form.section_id" :loading="loadingState.courses">
                        <el-option v-for="course in coursesForForm" :key="course.id" :label="course.subject.name" :value="course.id" />
                        </el-select>
                    </el-form-item>
                  </el-col>
              </el-row>
          </div>
          <div v-show="activeStep === 1">
              <el-alert title="الخطوة الثانية: تفاصيل التقييم" description="أدخل المعلومات الأساسية للتقييم مثل العنوان، النوع، والدرجة." type="info" :closable="false" show-icon style="margin-bottom: 20px;" />
              <el-form-item label="عنوان التقييم" prop="title">
                  <el-input v-model="form.title" placeholder="مثال: الامتحان النصفي للفصل الأول" />
              </el-form-item>
              <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="نوع التقييم" prop="assessment_type_id">
                        <el-select v-model="form.assessment_type_id" placeholder="اختر النوع" style="width: 100%;"><el-option v-for="type in meta.assessmentTypes" :key="type.id" :label="type.name" :value="type.id" /></el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="الفصل الدراسي" prop="term_id">
                        <el-select v-model="form.term_id" placeholder="اختر الفصل الدراسي" style="width: 100%;"><el-option v-for="term in meta.terms" :key="term.id" :label="term.name" :value="term.id" /></el-select>
                    </el-form-item>
                  </el-col>
              </el-row>
              <el-form-item label="الدرجة القصوى" prop="max_score">
                  <el-input-number v-model="form.max_score" :min="0" />
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="تاريخ النشر للطلاب (اختياري)">
                    <el-date-picker v-model="form.publish_date_time" type="datetime" style="width: 100%;" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="تاريخ التسليم النهائي (اختياري)">
                    <el-date-picker v-model="form.due_date_time" type="datetime" style="width: 100%;" />
                  </el-form-item>
                </el-col>
              </el-row>
               <el-form-item label="الوصف / التعليمات" prop="description">
                  <el-input v-model="form.description" type="textarea" :rows="3" />
              </el-form-item>
              <el-divider content-position="left">خيارات إضافية</el-divider>
              <el-form-item label="إعدادات الرؤية والنشر">
                  <el-checkbox v-model="form.is_visible_to_students" label="مرئي للطلاب" border />
                  <el-checkbox v-model="form.are_grades_published" label="الدرجات منشورة" border />
                  <el-checkbox v-model="form.is_online_quiz" label="اختبار إلكتروني (يحتوي على أسئلة)" border />
              </el-form-item>
          </div>
          <div v-show="activeStep === 2">
              <el-alert title="الخطوة الثالثة (اختياري): إضافة أسئلة" description="إذا كان هذا اختباراً إلكترونياً، يمكنك إضافة الأسئلة وخياراتها هنا." type="info" :closable="false" show-icon style="margin-bottom: 20px;" />
              <div v-for="(question, qIndex) in form.questions" :key="qIndex" class="question-card">
                  <el-card shadow="never">
                  <template #header>
                      <div class="card-header">
                      <span>السؤال {{ qIndex + 1 }}</span>
                      <el-button type="danger" :icon="Delete" circle @click="removeQuestion(qIndex)" />
                      </div>
                  </template>
                  <el-form-item :label="`نص السؤال`" :prop="`questions.${qIndex}.question_text`" :rules="{ required: true, message: 'نص السؤال مطلوب', trigger: 'blur' }">
                      <el-input v-model="question.question_text" type="textarea" :rows="2" />
                  </el-form-item>
                  <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item :label="`الدرجة`" :prop="`questions.${qIndex}.points`" :rules="{ required: true, message: 'الدرجة مطلوبة', trigger: 'blur' }">
                            <el-input-number v-model="question.points" :min="0" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="نوع السؤال">
                            <el-select v-model="question.question_type" placeholder="اختر النوع" style="width: 100%;">
                              <el-option label="اختيار من متعدد (إجابة واحدة)" value="multiple_choice_single_answer"></el-option>
                              <el-option label="اختيار من متعدد (عدة إجابات)" value="multiple_choice_multiple_answers"></el-option>
                              <el-option label="صح / خطأ" value="true_false"></el-option>
                              <el-option label="إجابة قصيرة" value="short_answer"></el-option>
                              <el-option label="مقالي" value="essay"></el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>
                  </el-row>
                  <el-divider content-position="left">الإجابات</el-divider>
                  <div v-if="question.question_type === 'multiple_choice_single_answer'">
                      <div v-for="(option, oIndex) in question.options" :key="oIndex" class="option-row">
                      <el-radio v-model="question.correct_answer_index" :label="oIndex" size="large">الإجابة الصحيحة</el-radio>
                      <el-input v-model="option.option_text" placeholder="نص الخيار" />
                      <el-button type="danger" :icon="Close" circle plain @click="removeOption(qIndex, oIndex)" />
                      </div>
                      <el-button type="primary" plain @click="addOption(qIndex)">إضافة خيار</el-button>
                  </div>
                  <div v-if="question.question_type === 'multiple_choice_multiple_answers'">
                      <div v-for="(option, oIndex) in question.options" :key="oIndex" class="option-row">
                      <el-checkbox v-model="option.is_correct_answer" size="large">إجابة صحيحة</el-checkbox>
                      <el-input v-model="option.option_text" placeholder="نص الخيار" />
                      <el-button type="danger" :icon="Close" circle plain @click="removeOption(qIndex, oIndex)" />
                      </div>
                      <el-button type="primary" plain @click="addOption(qIndex)">إضافة خيار</el-button>
                  </div>
                  <div v-if="question.question_type === 'true_false'">
                      <el-radio-group v-model="question.true_false_answer">
                          <el-radio :label="true" size="large" border>صح</el-radio>
                          <el-radio :label="false" size="large" border>خطأ</el-radio>
                      </el-radio-group>
                  </div>
                  <div v-if="question.question_type === 'short_answer' || question.question_type === 'essay'">
                      <el-input placeholder="سيقوم الطالب بكتابة الإجابة هنا" disabled />
                  </div>
                  </el-card>
              </div>
              <el-button @click="addQuestion" style="margin-top: 20px;" :icon="Plus">إضافة سؤال جديد</el-button>
          </div>
        </el-form>
        <div class="step-actions">
            <el-button @click="prevStep" v-if="activeStep > 0">السابق</el-button>
            <el-button type="primary" @click="nextStep" v-if="activeStep < 2">التالي</el-button>
            <el-button type="success" @click="submitAssessment" :loading="formLoading" v-if="(activeStep === 1 && !form.is_online_quiz) || activeStep === 2">
                إنهاء وحفظ التقييم
            </el-button>
        </div>
      </div>

      <div v-if="viewMode === 'grade'">
        <div class="card-header">
          <h2 v-if="gradingAssessment">رصد درجات لـ: {{ gradingAssessment.title }}</h2>
          <el-button @click="showListView">الرجوع للقائمة</el-button>
        </div>
        <el-divider />
        <div v-if="gradingAssessment && !gradingAssessment.is_online_quiz">
          <el-table :data="studentsToGrade" v-loading="isGradingLoading" border height="500px">
            <el-table-column prop="name" label="اسم الطالب" fixed width="250" />
            <el-table-column label="حالة التسليم" width="200">
              <template #default="{ row }">
                <el-select v-model="row.score_record.status" placeholder="الحالة">
                  <el-option label="لم يسلم بعد" value="Pending Submission"></el-option>
                  <el-option label="تم التسليم" value="Submitted"></el-option>
                  <el-option label="متأخر" value="Late Submission"></el-option>
                  <el-option label="تم الرصد" value="Graded"></el-option>
                  <el-option label="غائب" value="Missing"></el-option>
                  <el-option label="معذور" value="Excused"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="الدرجة">
              <template #default="{ row }">
                <el-input-number v-model="row.score_record.score_obtained" :min="0" :max="row.max_score" @change="onScoreChange(row)" :disabled="row.score_record.status === 'Pending Submission' || row.score_record.status === 'Missing'"/>
                 / {{ row.max_score }}
              </template>
            </el-table-column>
          </el-table>
          <div class="actions-footer">
            <el-button type="success" @click="submitDirectGrades" :loading="isSavingGrades">حفظ الدرجات</el-button>
          </div>
        </div>
        <div v-if="gradingAssessment && gradingAssessment.is_online_quiz">
           <el-table :data="studentSubmissions" v-loading="isGradingLoading" border>
                <el-table-column prop="student.name" label="اسم الطالب" />
                <el-table-column prop="submission.status" label="الحالة" />
                <el-table-column prop="submission.score_obtained" label="الدرجة النهائية" />
                <el-table-column label="الإجراء">
                    <template #default="{ row }">
                        <el-button v-if="row.submission.id" size="small" type="primary" @click="openSubmissionDetails(row.submission)">
                            عرض وتصحيح التسليم
                        </el-button>
                         <span v-else>لم يسلم بعد</span>
                    </template>
                </el-table-column>
           </el-table>
        </div>
      </div>

       <el-dialog v-model="isGradingDetailVisible" title="تصحيح تسليم الطالب" width="70%" top="5vh" fullscreen>
            <div v-if="gradingSubmissionDetails" v-loading="isDetailLoading">
                <div class="grading-header">
                    <h3>الطالب: {{ gradingSubmissionDetails.student.name }}</h3>
                    <h4>الدرجة المحتسبة تلقائياً: {{ autoCalculatedScore }} / {{ gradingAssessment.max_score }}</h4>
                </div>
                <div v-for="(question, qIndex) in gradingSubmissionDetails.assessment.quiz_questions" :key="question.id" class="question-review">
                    <p><strong>{{ qIndex + 1 }}. {{ question.question_text }} ({{ question.points }} درجات)</strong></p>
                    <div v-if="isManuallyGraded(question.question_type)">
                    <p><strong>إجابة الطالب:</strong></p>
                    <el-input type="textarea" :model-value="getStudentAnswer(question.id).answer_text || 'لم تتم الإجابة'" disabled :rows="3" />
                    <el-form-item label="الدرجة الممنوحة" style="margin-top: 10px;">
                        <el-input-number v-model="getStudentAnswer(question.id).points_awarded" :min="0" :max="parseFloat(question.points)" @change="recalculateFinalScore" />
                    </el-form-item>
                    </div>
                    <div v-else>
                    <p><strong>إجابة الطالب:</strong> {{ getStudentAnswerOptionText(question.id) }} 
                        <el-tag :type="isAnswerCorrect(question.id) ? 'success' : 'danger'" size="small">
                        {{ isAnswerCorrect(question.id) ? 'صحيحة' : 'خاطئة' }}
                        </el-tag>
                    </p>
                    <p><strong>الإجابة الصحيحة:</strong> {{ getCorrectOptionText(question) }}</p>
                    </div>
                    <el-divider />
                </div>
                <div class="final-score-section">
                    <el-form-item label="الدرجة النهائية (يمكن تعديلها)">
                    <el-input-number v-model="finalScore" :min="0" :max="gradingAssessment.max_score" />
                    </el-form-item>
                </div>
            </div>
            <template #footer>
                <el-button @click="isGradingDetailVisible = false">إلغاء</el-button>
                <el-button type="primary" @click="submitFinalGrade" :loading="isSavingGrades">حفظ التصحيح والدرجة النهائية</el-button>
            </template>
       </el-dialog>

    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage, ElPopconfirm } from 'element-plus';
import { mapState } from 'vuex';
import { CollectionTag, EditPen, Finished, Plus, Delete, Close, Edit, Download, Monitor, School } from '@element-plus/icons-vue';

/* global XLSX */

export default {
  name: 'TeacherAssessment',
  components: { CollectionTag, EditPen, Finished, Plus, Delete, Close, Edit, Download, Monitor, School },
  data() {
    return {
      api: null,
      viewMode: 'list',
      
      // List View State
      assessments: [],
      loading: false,
      filters: { class_id: null, section_id: null },
      activeStudyYear: null,
      teacherClasses: [],
      sectionsForFilter: [],
      meta: { assessmentTypes: [], terms: [] },
      pagination: { current_page: 1, per_page: 15, total: 0 },
      
      // Create/Edit View State
      activeStep: 0,
      form: this.getInitialForm(),
      rules: {
        class_id: [{ required: true, message: 'الفصل الدراسي مطلوب', trigger: 'change' }],
        section_id: [{ required: true, message: 'القسم مطلوب', trigger: 'change' }],
        course_offering_id: [{ required: true, message: 'المقرر الدراسي مطلوب', trigger: 'change' }],
        title: [{ required: true, message: 'عنوان التقييم مطلوب', trigger: 'blur' }],
        assessment_type_id: [{ required: true, message: 'نوع التقييم مطلوب', trigger: 'change' }],
        term_id: [{ required: true, message: 'الفصل الدراسي مطلوب', trigger: 'change' }],
        max_score: [{ required: true, message: 'الدرجة القصوى مطلوبة', trigger: 'blur' }],
      },
      sectionsForForm: [],
      teacherCourses: [],
      coursesForForm: [],
      loadingState: { courses: false },
      formLoading: false,

      // Grading State
      gradingAssessment: null,
      studentsToGrade: [],
      studentSubmissions: [],
      isGradingLoading: false,
      isSavingGrades: false,
      isGradingDetailVisible: false,
      isDetailLoading: false,
      gradingSubmissionDetails: null,
      finalScore: 0,
    };
  },
  computed: {
    ...mapState(['userId']),
    dialogTitle() { return this.form.id ? 'تعديل التقييم' : 'إنشاء تقييم جديد'; },
     autoCalculatedScore() {
      if (!this.gradingSubmissionDetails || !this.gradingSubmissionDetails.quiz_answers) return 0;
      return this.gradingSubmissionDetails.quiz_answers.reduce((total, answer) => total + (parseFloat(answer.points_awarded) || 0), 0);
    },
  },
  created() {
    this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
    this.api.interceptors.request.use(config => {
      const token = localStorage.getItem('access_token');
      if (token) config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    });
    this.fetchAssessments();
    this.fetchInitialData();
  },
  methods: {
    // في قسم methods


    // في قسم methods داخل <script>

addQuestion() {
  this.form.questions.push({
    question_text: '',
    points: 1,
    question_type: 'multiple_choice_single_answer', // النوع الافتراضي
    
    // خاص بنوع الاختيار من متعدد (إجابة واحدة)
    correct_answer_index: 0, 
    
    // خاص بنوع الصح والخطأ
    true_false_answer: true, 
    
    // خاص بنوعي الاختيار من متعدد
    options: [
      { option_text: '', is_correct_answer: false },
      { option_text: '', is_correct_answer: false }
    ]
  });
},

removeQuestion(index) {
      this.form.questions.splice(index, 1);
    },
    addOption(qIndex) {
      this.form.questions[qIndex].options.push({ option_text: '', is_correct_answer: false });
    },
    removeOption(qIndex, oIndex) {
      this.form.questions[qIndex].options.splice(oIndex, 1);
    },
    async submitAssessment() {
      this.form.created_by_teacher_id = this.userId;
      await this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.formLoading = true;
        try {
          const assessmentResponse = await this.api.post('/assessments', this.form);
          const assessmentId = assessmentResponse.data.assessment.id;
          if (this.form.is_online_quiz && this.form.questions.length > 0) {
            const cleanQuestionsPayload = this.form.questions.map(q => {
              const questionData = { question_text: q.question_text, points: q.points, question_type: q.question_type };
              if (q.question_type === 'multiple_choice_single_answer') {
                questionData.options = q.options.map((opt, index) => ({ option_text: opt.option_text, is_correct_answer: index === q.correct_answer_index }));
              } else if (q.question_type === 'multiple_choice_multiple_answers') {
                questionData.options = q.options;
              } else if (q.question_type === 'true_false') {
                questionData.true_false_answer = q.true_false_answer;
              }
              return questionData;
            });
            await this.api.post(`/assessments/${assessmentId}/questions`, { questions: cleanQuestionsPayload });
          }
          ElMessage.success('تم حفظ التقييم بنجاح!');
          this.showListView();
        } catch (error) {
          const errorMsg = error.response?.data?.errors ? Object.values(error.response.data.errors).flat().join('<br/>') : (error.response?.data?.message || 'فشل في حفظ التقييم.');
          ElMessage.error({ message: errorMsg, dangerouslyUseHTMLString: true });
        } finally {
          this.formLoading = false;
        }
      });
    },
    async deleteAssessment(assessmentId) {
      try {
        await this.api.delete(`/assessments/${assessmentId}`);
        ElMessage.success('تم حذف التقييم بنجاح!');
        this.fetchAssessments();
      } catch (error) {
        ElMessage.error(error.response?.data?.message || 'فشل في حذف التقييم.');
      }
    },
nextStep() {
  // التحقق قبل الانتقال من الخطوة الأولى (اختيار المقرر)
  if (this.activeStep === 0) {
    // نطلب من النموذج التحقق من هذه الحقول الثلاثة فقط
    const fieldsToValidate = ['class_id', 'section_id', 'course_offering_id'];
    this.$refs.formRef.validateField(fieldsToValidate, (isValid) => {
      if (isValid) {
        this.activeStep++; // إذا كانت صحيحة، انتقل للخطوة التالية
      } else {
        ElMessage.error('يرجى اختيار الفصل والشعبة والمقرر للمتابعة.');
      }
    });
  } 
  // التحقق قبل الانتقال من الخطوة الثانية (تفاصيل التقييم)
  else if (this.activeStep === 1) {
    const fieldsToValidate = ['title', 'assessment_type_id', 'term_id', 'max_score'];
    this.$refs.formRef.validateField(fieldsToValidate, (isValid) => {
      if (isValid) {
        // ننتقل للخطوة الثالثة فقط إذا كان اختباراً إلكترونياً
        if (this.form.is_online_quiz) {
          this.activeStep++;
        } else {
          // إذا لم يكن كذلك، نخبر المستخدم بالضغط على زر الحفظ
          ElMessage.info('هذه هي الخطوة النهائية. اضغط على "إنهاء وحفظ".');
        }
      } else {
        ElMessage.error('يرجى ملء جميع حقول تفاصيل التقييم للمتابعة.');
      }
    });
  }
},

prevStep() {
  if (this.activeStep > 0) {
    this.activeStep--;
  }
},
    getInitialForm() { return { id: null, class_id: null, section_id: null, course_offering_id: null, title: '', assessment_type_id: null, term_id: null, max_score: 100, description: '', is_visible_to_students: true, is_online_quiz: false, are_grades_published: false, questions: [], publish_date_time: null, due_date_time: null, grading_due_date_time: null }; },
    showListView() { this.viewMode = 'list'; this.fetchAssessments(); },
    showCreateView() {
      this.form = this.getInitialForm();
      this.activeStep = 0;
      this.sectionsForForm = [];
      this.coursesForForm = [];
      this.viewMode = 'create';
    },
    async openEditDialog(assessment) {
        this.form = this.getInitialForm();
        const classId = assessment.course_offering?.class_id;
        if (!classId) {
            ElMessage.error("لا يمكن تحديد الصف لهذا التقييم.");
            return;
        }
        
        await this.fetchInitialData(); // Ensure teacherClasses is loaded
        
        this.form = { 
            ...this.getInitialForm(),
            ...assessment,
            class_id: classId,
        };

        this.viewMode = 'edit';
        
        // Use nextTick to ensure form is rendered before setting nested values
        this.$nextTick(async () => {
            await this.onFormClassChange();
            this.form.section_id = assessment.section_id;
            await this.onFormSectionChange();
            this.form.course_offering_id = assessment.course_offering_id;
        });
    },
    async fetchInitialData() {
      try {
        const [metaRes, classesRes] = await Promise.all([
            this.api.get('/teacher/assessment-dashboard-data'),
            this.api.get('/teacher/my-classes'),
        ]);
        this.meta.terms = metaRes.data.terms;
        this.meta.assessmentTypes = metaRes.data.assessment_types; // ✨ 2. جلب أنواع التقييمات من هنا
        this.activeStudyYear = metaRes.data.active_study_year;
        this.teacherClasses = classesRes.data;
        this.teacherCourses = metaRes.data.courses; // ✨ 3. تخزين قائمة المقررات الكاملة
      } catch (error) { ElMessage.error('فشل في جلب البيانات الأساسية.'); }
    },
    async fetchAssessments() {
        this.loading = true;
        try {
            const params = { page: this.pagination.current_page, ...this.filters };
            const response = await this.api.get('/teacher/assessments', { params });
            this.assessments = response.data.data;
            this.pagination = { ...response.data, data: undefined };
        } catch (error) { ElMessage.error('فشل في جلب التقييمات.'); } 
        finally { this.loading = false; }
    },
    handleCurrentChange(val) { this.pagination.current_page = val; this.fetchAssessments(); },
    handleClassFilterChange() {
        this.filters.section_id = null;
        this.sectionsForFilter = [];
        const selectedClass = this.teacherClasses.find(c => c.id === this.filters.class_id);
        if (selectedClass) { this.sectionsForFilter = selectedClass.sections || []; }
        this.fetchAssessments();
    },
    onFormClassChange() {
        this.form.section_id = null;
        this.sectionsForForm = [];
        const selectedClass = this.teacherClasses.find(c => c.id === this.form.class_id);
        if (selectedClass) { this.sectionsForForm = selectedClass.sections || []; }
        this.onFormSectionChange();
    },
    onFormSectionChange() {
        this.form.course_offering_id = null;
        this.coursesForForm = [];
        if (!this.form.section_id || !this.form.class_id) return;

        // بدلاً من طلب API جديد، نقوم بفلترة قائمة المقررات التي لدينا بالفعل
        this.coursesForForm = this.teacherCourses.filter(course => 
            course.class_id === this.form.class_id && 
            course.section_id === this.form.section_id
        );
    },
     async submitForm() {
      if (!this.$refs.formRef) return;
      await this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.formLoading = true;
        try {
          if (this.form.id) {
            await this.api.put(`/assessments/${this.form.id}`, this.form);
            ElMessage.success('تم تحديث التقييم بنجاح!');
          } else {
            await this.api.post('/assessments', this.form);
            ElMessage.success('تم إنشاء التقييم بنجاح!');
          }
          this.showListView();
        } catch (error) {
          const errorMsg = error.response?.data?.errors ? Object.values(error.response.data.errors).flat().join('<br/>') : (error.response?.data?.message || 'فشلت العملية.');
          ElMessage.error({ message: errorMsg, dangerouslyUseHTMLString: true });
        } finally {
          this.formLoading = false;
        }
      });
    },
    async deleteAssessment(assessmentId) {
        try {
            await this.api.delete(`/assessments/${assessmentId}`);
            ElMessage.success('تم حذف التقييم بنجاح!');
            this.fetchAssessments();
        } catch (error) { ElMessage.error(error.response?.data?.message || 'فشل في حذف التقييم.'); }
    },
    async openGradingView(assessment) {
        this.gradingAssessment = assessment;
        this.viewMode = 'grade';
        this.isGradingLoading = true;
        try {
            if (assessment.is_online_quiz) {
                const response = await this.api.get(`/assessments/${assessment.id}/submissions`);
                this.studentSubmissions = response.data;
            } else {
                const response = await this.api.get(`/assessments/${assessment.id}/grading-sheet`);
                this.studentsToGrade = response.data;
            }
        } catch (error) {
            ElMessage.error('فشل في جلب بيانات الرصد.');
            this.showListView();
        } finally {
            this.isGradingLoading = false;
        }
    },
     async openGradingView(assessment) {
        this.gradingAssessment = assessment;
        this.viewMode = 'grade';
        this.isGradingLoading = true;
        try {
            if (assessment.is_online_quiz) {
                const response = await this.api.get(`/assessments/${assessment.id}/submissions`);
                this.studentSubmissions = response.data;
            } else {
                const response = await this.api.get(`/assessments/${assessment.id}/grading-sheet`);
                this.studentsToGrade = response.data;
            }
        } catch (error) { ElMessage.error('فشل في جلب بيانات الرصد.'); this.showListView(); }
        finally { this.isGradingLoading = false; }
    },
    onScoreChange(studentRow) {
      if (studentRow.score_record.score_obtained !== null && studentRow.score_record.score_obtained >= 0) {
        studentRow.score_record.status = 'Graded';
      }
    },
    async submitDirectGrades() {
        this.isSavingGrades = true;
        try {
            const payload = {
                scores: this.studentsToGrade.map(student => ({
                    student_id: student.id,
                    score_obtained: student.score_record.score_obtained,
                    status: student.score_record.status,
                }))
            };
            await this.api.post(`/assessments/${this.gradingAssessment.id}/scores`, payload);
            ElMessage.success('تم حفظ الدرجات بنجاح!');
            this.showListView();
        } catch (error) { ElMessage.error('فشل في حفظ الدرجات.'); } 
        finally { this.isSavingGrades = false; }
    },
    async openSubmissionDetails(submission) {
        this.isGradingDetailVisible = true;
        this.isDetailLoading = true;
        try {
            const response = await this.api.get(`/submissions/${submission.id}/details`);
            this.gradingSubmissionDetails = response.data;
            this.finalScore = this.gradingSubmissionDetails.score_obtained || this.autoCalculatedScore;
        } catch (error) {
            ElMessage.error('فشل في جلب تفاصيل التسليم.');
            this.isGradingDetailVisible = false;
        } finally {
            this.isDetailLoading = false;
        }
    },
    isManuallyGraded(type) { return ['short_answer', 'essay'].includes(type); },
    getStudentAnswer(questionId) {
        if (!this.gradingSubmissionDetails) return { points_awarded: 0 };
        return this.gradingSubmissionDetails.quiz_answers.find(a => a.quiz_question_id === questionId) || { points_awarded: 0 };
    },
    getStudentAnswerOptionText(questionId) {
        const answer = this.getStudentAnswer(questionId);
        return answer?.chosen_option?.option_text || 'لم يختر إجابة';
    },
    isAnswerCorrect(questionId) {
        return this.getStudentAnswer(questionId)?.is_marked_correct || false;
    },
    getCorrectOptionText(question) {
        const correctOption = question.options.find(o => o.is_correct_answer);
        return correctOption ? correctOption.option_text : 'N/A';
    },
    recalculateFinalScore() {
        this.finalScore = this.autoCalculatedScore;
    },
    async submitFinalGrade() {
        this.isSavingGrades = true;
        try {
            const manuallyGradedAnswers = this.gradingSubmissionDetails.assessment.quiz_questions
                .filter(q => this.isManuallyGraded(q.question_type))
                .map(q => {
                    const answer = this.getStudentAnswer(q.id);
                    return { id: answer.id, points_awarded: answer.points_awarded };
                }).filter(a => a.id);
            const payload = { answers: manuallyGradedAnswers, final_score: this.finalScore };
            await this.api.post(`/submissions/${this.gradingSubmissionDetails.id}/grade`, payload);
            ElMessage.success('تم حفظ التصحيح بنجاح!');
            this.isGradingDetailVisible = false;
            this.openGradingView(this.gradingAssessment);
        } catch (error) {
            ElMessage.error('فشل في حفظ التصحيح.');
        } finally {
            this.isSavingGrades = false;
        }
    },
// في قسم methods داخل <script>

async exportGrades(assessment) {
    ElMessage.info('جاري تجهيز التقرير...');
    try {
        // أولاً، نجلب ورقة الرصد الكاملة من الـ API
        const response = await this.api.get(`/assessments/${assessment.id}/grading-sheet`);
        const gradingSheet = response.data;

        if (!gradingSheet || gradingSheet.length === 0) {
            ElMessage.warning('لا يوجد طلاب في هذه الشعبة لتصدير درجاتهم.');
            return;
        }

        // --- ✨ بداية التعديل الرئيسي هنا ✨ ---

        // 1. تجهيز بيانات رأس التقرير (Header)
        const reportHeader = [
            ["عنوان التقييم:", assessment.title],
            ["المعلم:", assessment.created_by_teacher.name],
            ["المادة:", assessment.course_offering?.subject?.name || 'N/A'],
            ["الفصل / الشعبة:", `${assessment.course_offering?.school_class?.name || ''} / ${assessment.section?.name || ''}`],
            ["نوع التقييم:", assessment.assessment_type?.name || 'N/A'],
            ["الدرجة القصوى:", assessment.max_score],
            ["تاريخ الإنشاء:", new Date(assessment.created_at).toLocaleDateString()],
            ["تسليم إلكتروني؟:", assessment.is_online_quiz ? 'نعم' : 'لا'],
            ["مرئي للطلاب؟:", assessment.is_visible_to_students ? 'نعم' : 'لا'],
            [], // سطر فارغ للفصل بين رأس التقرير والجدول
        ];

        // 2. تجهيز بيانات الطلاب والدرجات (Table Body)
        const studentData = gradingSheet.map(student => {
            const scoreRecord = student.score_record || {};
            return {
                "رقم القيد": student.srn || 'N/A',
                "اسم الطالب": student.name || 'N/A',
                "حالة التسليم": scoreRecord.status || 'N/A',
                "الدرجة المرصودة": scoreRecord.score_obtained !== null && scoreRecord.score_obtained !== undefined 
                    ? scoreRecord.score_obtained 
                    : 'لم ترصد',
                "تاريخ الرصد": scoreRecord.grading_timestamp ? new Date(scoreRecord.grading_timestamp).toLocaleString() : '-',
            };
        });

        // 3. إنشاء ورقة العمل ودمج البيانات
        const ws = XLSX.utils.aoa_to_sheet(reportHeader);

        // إضافة جدول الطلاب ابتداءً من الصف العاشر (لترك مسافة بعد الهيدر)
        XLSX.utils.sheet_add_json(ws, studentData, { origin: "A11" }); // تم تغيير origin ليبدأ بعد الهيدر الجديد


        // (اختياري) تعديل عرض الأعمدة ليكون مناسباً
        ws['!cols'] = [ { wch: 15 }, { wch: 35 }, { wch: 20 }, { wch: 15 }, { wch: 25 } ];

        // 4. إنشاء وتنزيل الملف النهائي
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Grades Report');
        
        const fileName = `Grades_${assessment.title.replace(/\s+/g, '_')}.xlsx`;
        XLSX.writeFile(wb, fileName);

        // --- نهاية التعديل الرئيسي --- ✨

    } catch (error) {
        console.error("Export Error:", error);
        ElMessage.error('فشل في تصدير التقرير.');
    }
},
// في قسم methods

async printGradesReport(assessment) {
    ElMessage.info('جاري تجهيز التقرير للطباعة...');
    try {
        const response = await this.api.get(`/assessments/${assessment.id}/grading-sheet`);
        const gradingSheet = response.data;

        if (!gradingSheet || gradingSheet.length === 0) {
            return ElMessage.warning('لا يوجد طلاب لطباعة درجاتهم.');
        }

        const logoUrl = `${window.location.origin}/logo-school-one.png`;

        // --- بناء رأس التقرير ---
        const reportHeaderHtml = `
            <div class="report-header">
                <img src="${logoUrl}" alt="School Logo" />
                <h1>كشف درجات التقييم</h1>
                <h2>${assessment.title}</h2>
            </div>
            <table class="details-table">
                <tr><td><strong>المعلم:</strong></td><td>${assessment.created_by_teacher.name}</td></tr>
                <tr><td><strong>المادة:</strong></td><td>${assessment.course_offering.subject.name}</td></tr>
                <tr><td><strong>الفصل / الشعبة:</strong></td><td>${assessment.course_offering.school_class.name} / ${assessment.section.name}</td></tr>
                <tr><td><strong>نوع التقييم:</strong></td><td>${assessment.assessment_type.name}</td></tr>
                <tr><td><strong>الدرجة القصوى:</strong></td><td>${assessment.max_score}</td></tr>
            </table>
        `;

        // --- بناء جدول الدرجات ---
        const tableHeaders = `
            <tr>
                <th>رقم القيد</th>
                <th>اسم الطالب</th>
                <th>حالة التسليم</th>
                <th>الدرجة المرصودة</th>
                <th>تاريخ الرصد</th>
            </tr>
        `;
        const tableRows = gradingSheet.map(student => {
            const scoreRecord = student.score_record || {};
            const score = scoreRecord.score_obtained !== null && scoreRecord.score_obtained !== undefined 
                ? scoreRecord.score_obtained 
                : 'لم ترصد';
            const gradingDate = scoreRecord.grading_timestamp ? new Date(scoreRecord.grading_timestamp).toLocaleString('ar-LY') : '-';
            return `
                <tr>
                    <td>${student.srn || 'N/A'}</td>
                    <td class="student-name">${student.name || 'N/A'}</td>
                    <td>${scoreRecord.status || 'N/A'}</td>
                    <td>${score}</td>
                    <td>${gradingDate}</td>
                </tr>
            `;
        }).join('');

        // --- تجميع كل شيء في صفحة HTML واحدة ---
        const printContent = `
            <html>
                <head>
                    <title>Grades Report - ${assessment.title}</title>
                    <style>
                        @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;700&display=swap');
                        body { font-family: 'Tajawal', sans-serif; direction: rtl; }
                        .report-container { width: 95%; margin: auto; }
                        .report-header { text-align: center; margin-bottom: 20px; }
                        .report-header img { max-width: 120px; }
                        .report-header h1 { margin: 5px 0; color: #002d55; }
                        .details-table { width: 100%; margin-bottom: 20px; border: 1px solid #eee; border-collapse: collapse; }
                        .details-table td { padding: 8px; border: 1px solid #eee; }
                        .main-table { width: 100%; border-collapse: collapse; font-size: 12px; }
                        .main-table th, .main-table td { border: 1px solid #ccc; padding: 8px; text-align: center; }
                        .main-table th { 
                            /* ✨--- هذا هو الجزء الخاص بتلوين الخلفية ---✨ */
                            background-color: #002d55 !important; 
                            color: white !important; 
                            -webkit-print-color-adjust: exact; 
                            print-color-adjust: exact;
                        }
                        .main-table tr:nth-child(even) { background-color: #f9f9f9 !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .main-table td.student-name { text-align: right; }
                    </style>
                </head>
                <body>
                    <div class="report-container">
                        ${reportHeaderHtml}
                        <table class="main-table">
                            <thead>${tableHeaders}</thead>
                            <tbody>${tableRows}</tbody>
                        </table>
                    </div>
                </body>
            </html>
        `;

        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => { printWindow.print(); printWindow.close(); }, 500);

    } catch (error) {
        console.error("Print Error:", error);
        ElMessage.error('فشل في تجهيز التقرير للطباعة.');
    }
}
  },
};
</script>

<style scoped>
.actions-footer { margin-top: 20px; text-align: right; }
</style>